<template>
  <router-view />
</template>

<script></script>

<style>
#app {
  height: 100%;
}
</style>
